export default "__VITE_ASSET__BNo6OV8B__"